// Secções do backoffice (docs/PLATAFORMA.md §7). "milestone" = marco em que a secção ganha conteúdo;
// "permission" = o que é preciso para a ver (o backend volta a verificar em cada pedido).
import type { Permission } from "@ecliptica/contexts-accounts";
import { Gauge, Globe, Layers, LifeBuoy, ScrollText, Settings, Sparkles, UserCog, Users, type LucideIcon } from "lucide-react";

export type SectionKey = "dashboard" | "editions" | "cards" | "users" | "roles" | "support" | "site" | "audit" | "settings";

export const SECTIONS: { key: SectionKey; path: string; icon: LucideIcon; permission: Permission; milestone?: string }[] = [
  { key: "dashboard", path: "/", icon: Gauge, permission: "backoffice.access" },
  { key: "editions", path: "/editions", icon: Sparkles, permission: "content.edit", milestone: "W6" },
  { key: "cards", path: "/cards", icon: Layers, permission: "content.read" },
  { key: "users", path: "/users", icon: Users, permission: "users.read" },
  // Só quem gere papéis vê a página (a lista em si é lida por toda a equipa para nomes e filtros).
  { key: "roles", path: "/roles", icon: UserCog, permission: "roles.manage" },
  { key: "support", path: "/support", icon: LifeBuoy, permission: "support.read" },
  { key: "site", path: "/site", icon: Globe, permission: "backoffice.access" },
  { key: "audit", path: "/audit", icon: ScrollText, permission: "audit.read" },
  { key: "settings", path: "/settings", icon: Settings, permission: "backoffice.access" },
];
